export default function ProcessSection() {
  const steps = [
    {
      number: '1',
      title: 'Contact Us',
      description: 'Call us at (610) 253-2835 or fill out our online quote form. Tell us about your event, date, and what you need.',
      icon: 'ri-phone-fill'
    },
    {
      number: '2',
      title: 'Get Your Free Quote',
      description: 'We\'ll provide a detailed quote with transparent pricing. No hidden fees, just honest pricing for quality service.',
      icon: 'ri-file-list-3-fill'
    },
    {
      number: '3',
      title: 'We Deliver & Setup',
      description: 'On your event day, we arrive on time, set up everything professionally, and ensure it\'s safe and ready to go.',
      icon: 'ri-truck-fill'
    },
    {
      number: '4',
      title: 'Enjoy Your Event',
      description: 'Relax and enjoy your celebration! We handle all the details so you can focus on making memories with your guests.',
      icon: 'ri-emotion-happy-fill'
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Sora, sans-serif' }}>
            How It Works
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Getting started with Fun Affairs is easy. Follow these simple steps to make your event unforgettable.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              <div className="text-center">
                <div className="relative inline-block mb-6">
                  <div className="w-20 h-20 flex items-center justify-center bg-gradient-to-br from-red-600 to-orange-500 rounded-2xl shadow-lg">
                    <i className={`${step.icon} text-3xl text-white`}></i>
                  </div>
                  <div className="absolute -top-2 -right-2 w-10 h-10 flex items-center justify-center bg-amber-400 rounded-full text-gray-900 font-bold text-lg shadow-lg">
                    {step.number}
                  </div>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {step.title}
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed">
                  {step.description}
                </p>
              </div>
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-10 left-full w-full h-0.5 bg-gradient-to-r from-red-300 to-orange-300 transform -translate-x-1/2"></div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}